import EnterTournamentLightbox from "../containers/enter-tournament-lightbox";
import expandable from "./higher-order/expandable";
import NotificationButton from "./notification-button";
import React from "react";
import { TooltipBlock } from "./tooltip";
import TournamentStatusText from "./tournament-status-text";
import { trackEvent } from "../analytics";

export default expandable(class TournamentStatus extends React.PureComponent {

  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    var { expanded, isGameBoard, toggle, tournament } = this.props;

    toggle();
    if (!expanded) {
      trackEvent(isGameBoard ? "Game Board" : "Tournament List", "show_enter_tournament", tournament.get("name"), tournament.get("id"));
    }
  }

  render() {
    var { expanded, isGameBoard, myTickets, toggle, tournament } = this.props;

    if (tournament.get("status") === "open" || tournament.get("status") === "scheduled") {
      var isFull = tournament.get("remaining_entries") === 0;

      var text = "Enter";
      if (isFull) {
        text = "Full";
      }

      var lightbox;
      if (expanded) {
        lightbox = <EnterTournamentLightbox isGameBoard={isGameBoard} onClose={toggle} tournament={tournament} />;
      }

      return (
        <div>
          <TooltipBlock text={myTickets.size === 0 ? "" : "You have " + myTickets.size + " entries in this game."}>
            <NotificationButton amount={myTickets.size} error={isFull} naked={isFull} onClick={this.toggle} primary={!isFull} small>
              {text}
            </NotificationButton>
          </TooltipBlock>

          {lightbox}
        </div>
      );
    }
    return (
      <div>
        <span aria-label="Status" className="tournament-table_label tournament-table_mobile-label">
          <TournamentStatusText animated={isGameBoard} status={tournament.get("status")} />
        </span>
      </div>
    );
  }
});
